import axiosClient from "../lib/axiosClient";

export const generateMetadescription = async (content) => {
  try {
    const response = await axiosClient.post("/free-tools/generate-meta-description", { content });
    return response;
  } catch (error) {
    throw error;
  }
};

export const generateSeoTitle = async (content) => {
  try {
    const response = await axiosClient.post("/free-tools/generate-seo-title", { content });
    return response;
  } catch (error) {
    throw error;
  }
};

export const generateKeywordClusters = async (keywords) => {
  try {
    const response = await axiosClient.post("/free-tools/generate-clusters", { keywords });
    return response;
  } catch (error) {
    throw error;
  }
};
export const generateInstagramCaption = async (body) => {
  try {
    const response = await axiosClient.post("/free-tools/generate-instagram-caption", body);
    return response;
  } catch (error) {
    throw error;
  }
};

export const generateRobotTxt = async (body) => {
  try {
    const response = await axiosClient.post("/free-tools/generate-robots-txt", body);
    return response;
  } catch (error) {
    throw error;
  }
};

export const generateTopicalMap = async (body) => {
  try {
    const response = await axiosClient.post("/free-tools/generate-topical-map", body);
    return response;
  } catch (error) {
    throw error;
  }
};
